import React, { Component } from "react";

import { FormGroup } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import _ from "lodash";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import Multiselect from "react-widgets/lib/Multiselect";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

// Css
import "../../assets/css/groupmanagement.css";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    editDetailsBtn: "Edit Details",
    groupDetailsHeader: "Edit Group",
    groupNameHeader: "Group Name",
    groupNamePlaceholder: "Enter Group Name",
    groupDescriptionHeader: "Group Description (optional)",
    groupDescriptionPlaceholder: "Enter Group Description",
    // addMembersHeader: "Add Members",
    addMembersHeader: "Select Members",
    addMembersPlaceholder: "-Select Members-",
    removeMemberBtn: "Remove Member",
    nameHeader: "Name",
    emailHeader: "Email",
    selectedMembersHeader: "Group Member List",
    saveTitle: "Save",
    cancelTitle: "Cancel",
    noDataTitle: "There is no data to display",
    searchPlaceholder: "Search",
    loading: "Loading...",
    emptyFormAlert:
      "Please enter a group name and select at least 2 group members",
    enterGroupNameAlert: "Please enter a group name",
    minimumMembersAlert:
      "Please ensure that you have selected at least 2 members to be added into the group",
    updateFailAlert: "Unable to update group details, Please try again",
    nameExistsAlert: "Group name already exists",
    updateSuccessAlert: "Group details updated successfully",
    adminRemovalAlert: "You cannot remove the admin of the group",
  },
  ja: {
    editDetailsBtn: "Edit Details",
    groupDetailsHeader: "グループ編集",
    groupNameHeader: "グループ名",
    groupNamePlaceholder: "グループ名入力",
    groupDescriptionHeader: "グループメモ（オプション）",
    groupDescriptionPlaceholder: "グループメモ入力",
    // addMembersHeader: "Add Members",
    addMembersHeader: "メンバー選択",
    addMembersPlaceholder: "-Select Members-",
    removeMemberBtn: "Remove Member",
    nameHeader: "名前",
    emailHeader: "Eメール",
    selectedMembersHeader: "グループメンバーリスト",
    saveTitle: "保存",
    cancelTitle: "キャンセル",
    noDataTitle: "表示するデータがありません。",
    searchPlaceholder: "検索",
    loading: "読み込み中...",
    emptyFormAlert:
      "グループ名を入力し、少なくとも 2 人のグループ メンバーを選択してください",
    enterGroupNameAlert: "グループ名を入力してください",
    minimumMembersAlert:
      "グループに追加するメンバーを少なくとも 2 人選択していることを確認してください",
    updateFailAlert: "グループの詳細を更新できません、もう一度お試しください",
    nameExistsAlert: "グループ名はすでに存在します",
    updateSuccessAlert: "グループの詳細が正常に更新されました",
    adminRemovalAlert: "グループの管理者を削除することはできません",
  },
  es: {
    editDetailsBtn: "Editar detalles",
    groupDetailsHeader: "Editar grupo",
    groupNameHeader: "Nombre del grupo",
    groupNamePlaceholder: "Ingrese el nombre del grupo",
    groupDescriptionHeader: "Descripción del grupo (opcional)",
    groupDescriptionPlaceholder: "Ingrese la descripción del grupo",
    addMembersHeader: "Seleccionar miembros",
    addMembersPlaceholder: "-Seleccionar miembros-",
    removeMemberBtn: "Eliminar miembro",
    nameHeader: "Nombre",
    emailHeader: "Correo electrónico",
    selectedMembersHeader: "Lista de miembros del grupo",
    saveTitle: "Guardar",
    cancelTitle: "Cancelar",
    noDataTitle: "No hay datos para mostrar",
    searchPlaceholder: "Buscar",
    loading: "Cargando...",
    emptyFormAlert:
      "Por favor ingresa un nombre de grupo y selecciona al menos 2 miembros del grupo",
    enterGroupNameAlert: "Por favor ingresa un nombre de grupo",
    minimumMembersAlert:
      "Asegúrese de haber seleccionado al menos 2 miembros para agregarlos al grupo",
    updateFailAlert:
      "No se pueden actualizar los detalles del grupo, inténtalo de nuevo",
    nameExistsAlert: "El nombre del grupo ya existe",
    updateSuccessAlert: "Detalles del grupo actualizados exitosamente",
    adminRemovalAlert: "No puedes eliminar al administrador del grupo",
  },
});

export class GroupDetailsButton extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;

    var memberemailarray = [];
    var memberarray = [];
    _.map(row.groupMembers, (memberData) => {
      memberarray.push(memberData);
      memberemailarray.push(memberData.memberEmail);
    });

    var originalmemberarray = [];
    _.map(this.props.rowValue.groupMembers, (memberData) => {
      originalmemberarray.push(memberData);
    });

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      groupID: row.groupID,
      groupName: row.groupName,
      groupNameExist: false,
      groupDesc: row.groupDesc,
      memberemaillistArray: [],
      groupsArrayList: [],
      selectedMember: memberarray,
      selectedMemberValue: memberemailarray,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      prevSelectedMember: originalmemberarray,
      loading: false,
      // memberemaillistArray: [],
      // groupmemberslistArray: [],
      // selectedMember: []
    };

    this.handleGroupDetailsPopupOpen = this.handleGroupDetailsPopupOpen.bind(
      this,
    );
    this.handleGroupDetailsPopupClose = this.handleGroupDetailsPopupClose.bind(
      this,
    );
    this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
    this.handleGroupDescChange = this.handleGroupDescChange.bind(this);
    this.handleSelectedMembers = this.handleSelectedMembers.bind(this);
    this.createCustomDeleteButton = this.createCustomDeleteButton.bind(this);
    this.customConfirmDialog = this.customConfirmDialog.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateGroupData = this.updateGroupData.bind(this);
    this.retrieveGroupDetails = this.retrieveGroupDetails.bind(this);
    this.filterSelectedMembers = this.filterSelectedMembers.bind(this);
    this.renderSelectMember = this.renderSelectMember.bind(this);
    this.unselectMember = this.unselectMember.bind(this);
    this.createCustomSearchFieldForm = this.createCustomSearchFieldForm.bind(
      this,
    );
    this.Disable = this.Disable.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    var originalmemberarray = [];
    _.map(nextProps.rowValue.groupMembers, (memberData) => {
      originalmemberarray.push(memberData);
    });
    this.setState({
      cell: nextProps.cellValue,
      row: nextProps.rowValue,
      prevSelectedMember: originalmemberarray,
    });
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });

    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        var memberArr = [];
        var eachMember = {};
        tempArray = this.snapshotToArray(snapshot);
        tempArray.forEach((e) => {
          //! FIND MEMBER UID
          fire
            .database()
            .ref("registeredUsersOnPlatform")
            .orderByValue()
            .equalTo(e.friendEmail)
            .once("value")
            .then((snapshots) => {
              if (snapshots.exists()) {
                e["memberUID"] = Object.keys(snapshots.val())[0];

                eachMember = {
                  memberEmail: e.friendEmail,
                  memberName: e.friendName,
                  memberUID: e["memberUID"],
                  memberDisplay: e.friendName + " | " + e.friendEmail,
                };

                memberArr.push(eachMember);
              }
            });
        });
        this.setState({
          memberemaillistArray: memberArr,
        });
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      // customLog(item)
      // customLog(item.key)

      returnArr.push(item);
    });
    // customLog(returnArr)
    return returnArr;
  };

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div style={{ textAlign: "start" }}>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  handleGroupDetailsPopupOpen() {
    this.setState({
      showPopup: true,
    });
  }

  handleGroupDetailsPopupClose() {
    var memberemailarray = [];
    var memberarray = [];
    _.map(this.state.row.groupMembers, (memberData) => {
      memberarray.push(memberData);
      memberemailarray.push(memberData.memberEmail);
    });

    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        var memberArr = [];
        var eachMember = {};
        tempArray = this.snapshotToArray(snapshot);
        tempArray.forEach((e) => {
          //! FIND MEMBER UID
          fire
            .database()
            .ref("registeredUsersOnPlatform")
            .orderByValue()
            .equalTo(e.friendEmail)
            .once("value")
            .then((snapshots) => {
              if (snapshots.exists()) {
                e["memberUID"] = Object.keys(snapshots.val())[0];

                eachMember = {
                  memberEmail: e.friendEmail,
                  memberName: e.friendName,
                  memberUID: e["memberUID"],
                  memberDisplay: e.friendName + " | " + e.friendEmail,
                };

                memberArr.push(eachMember);
              }
            });
        });
        this.setState({
          memberemaillistArray: memberArr,
          showPopup: false,
          groupNameExist: false,
          groupName: this.state.row.groupName,
          groupDesc: this.state.row.groupDesc,
          selectedMember: memberarray,
          selectedMemberValue: memberemailarray,
        });
      });
  }

  handleGroupNameChange(e) {
    this.setState({
      groupName: e.target.value,
    });
  }

  handleGroupDescChange(e) {
    this.setState({
      groupDesc: e.target.value,
    });
  }

  handleSelectedMembers(selectedMembers) {
    var memberemailarray = [];
    _.map(selectedMembers, (memberData) => {
      memberemailarray.push(memberData.memberEmail);
    });
    this.setState({
      selectedMember: selectedMembers,
      selectedMemberValue: memberemailarray,
    });
  }

  createCustomDeleteButton = (onBtnClick) => {
    return (
      <Button id="deleteMemberBtn" onClick={onBtnClick}>
        <i className="far fa-trash-alt" /> {localizationStrings.removeMemberBtn}
      </Button>
    );
  };

  customConfirmDialog(next) {
    next();
  }

  onAfterDeleteRow(emailDeleted) {
    var memberemailarray;
    var selectedMembers;

    memberemailarray = this.state.selectedMemberValue.filter(
      (value) => !emailDeleted.includes(value),
    );
    selectedMembers = this.state.selectedMember.filter(
      (value) => !emailDeleted.includes(value.memberEmail),
    );

    this.setState({
      selectedMember: selectedMembers,
      selectedMemberValue: memberemailarray,
    });
  }

  // onSubmit() {
  //   // console.log(this.state.groupID);
  //   // console.log(this.state.groupName);
  //   // console.log(this.state.groupDesc);
  //   // console.log(this.state.selectedMember);
  //   // console.log(this.state.selectedMemberValue);

  //   this.setState({ loading: true });

  //   if (this.state.groupName != "" && this.state.selectedMember.length > 1) {
  //     this.setState({
  //       groupNameExist: false,
  //     });
  //     this.updateGroupData(this.state.superAdminID);
  //   } else if (
  //     this.state.groupName == "" &&
  //     this.state.selectedMember.length < 2
  //   ) {
  //     this.showNotification(
  //       localizationStrings.emptyFormAlert,
  //       "error",
  //       "tc",
  //       5
  //     );
  //     this.setState({ loading: false });
  //   } else if (this.state.groupName == "") {
  //     this.showNotification(
  //       localizationStrings.enterGroupNameAlert,
  //       "error",
  //       "tc",
  //       5
  //     );
  //     this.setState({ loading: false });
  //   } else if (this.state.selectedMember.length < 2) {
  //     this.showNotification(
  //       localizationStrings.minimumMembersAlert,
  //       "error",
  //       "tc",
  //       5
  //     );
  //     this.setState({ loading: false });
  //   } else {
  //     this.showNotification(
  //       localizationStrings.updateFailAlert,
  //       "error",
  //       "tc",
  //       5
  //     );
  //     this.setState({ loading: false });
  //   }
  // }

  onSubmit = async () => {

    const { groupName, selectedMember, superAdminID } = this.state;

    if (groupName.trim() === "" && selectedMember.length < 2) {
      this.showNotification(
        localizationStrings.emptyFormAlert,
        "error",
        "tc",
        5,
      );
      return;
    }

    if (groupName.trim() === "") {
      this.showNotification(
        localizationStrings.enterGroupNameAlert,
        "error",
        "tc",
        5,
      );
      return;
    }

    if (selectedMember.length < 2) {
      this.showNotification(
        localizationStrings.minimumMembersAlert,
        "error",
        "tc",
        5,
      );
      return;
    }

    try {

      this.setState({
        loading: true,
        groupNameExist: false,
      });
      await this.updateGroupData(superAdminID);
    } catch (error) {
      console.error("onSubmit Error:", error);

      this.showNotification(
        localizationStrings.updateFailAlert,
        "error",
        "tc",
        5,
      );
    } finally {
      this.setState({ loading: false });
    }
  };
  async updateGroupData(superAdminID) {

    try {
      const {
        groupName,
        groupDesc,
        groupID,
        row,
        selectedMember,
        prevSelectedMember,
      } = this.state;

      const currentUID = auth.currentUser.uid;
      const currentEmail = auth.currentUser.email;

      //! 1. CHECK IF GROUP NAME ALREADY EXISTS

      const groupSnapshot = await fire
        .database()
        .ref("GroupManagement")
        .child(superAdminID)
        .child(currentUID)
        .once("value");

      let groupNameExist = false;

      if (groupSnapshot.exists()) {
        groupSnapshot.forEach((group) => {
          const groupValue = group.val();

          if (
            groupName === groupValue.groupName &&
            row.groupName !== groupValue.groupName
          ) {
            groupNameExist = true;
          }
        });
      }


      if (groupNameExist) {
        this.setState({ groupNameExist: true });

        this.showNotification(
          localizationStrings.nameExistsAlert,
          "error",
          "tc",
          5,
        );

        return;
      }

      //! 2. BUILD MEMBER OBJECTS + SINGLE MULTI-PATH UPDATE

      let groupMembersWithUID = {};
      let newGroupMembersUID = [];
      let updates = {};

      for (let i = 0; i < selectedMember.length; i++) {
        const eachGroupMember = selectedMember[i];
        const memberUID = eachGroupMember.memberUID;

        groupMembersWithUID[memberUID] = {
          memberEmail: eachGroupMember.memberEmail,
          memberName: eachGroupMember.memberName,
          memberUID: memberUID,
        };

        newGroupMembersUID.push(memberUID);

        updates[
          `/groupAccounts/${superAdminID}/userGroups/${memberUID}/memberEmail`
        ] = eachGroupMember.memberEmail;

        updates[
          `/groupAccounts/${superAdminID}/userGroups/${memberUID}/groups/${groupID}`
        ] = {
          groupAdminEmail: currentEmail,
          groupAdminUID: currentUID,
          groupID: groupID,
        };
      }


      //! 3. REMOVE OLD MEMBERS NOT IN NEW LIST

      for (let i = 0; i < prevSelectedMember.length; i++) {
        const eachOldGroupMemberUID = prevSelectedMember[i].memberUID;

        if (!newGroupMembersUID.includes(eachOldGroupMemberUID)) {
          updates[
            `/groupAccounts/${superAdminID}/userGroups/${eachOldGroupMemberUID}/groups/${groupID}`
          ] = null;
        }
      }


      //! 4. UPDATE GROUP MANAGEMENT DATA

      updates[
        `/GroupManagement/${superAdminID}/${currentUID}/${groupID}/groupName`
      ] = groupName;

      updates[
        `/GroupManagement/${superAdminID}/${currentUID}/${groupID}/groupDesc`
      ] = groupDesc;

      updates[
        `/GroupManagement/${superAdminID}/${currentUID}/${groupID}/groupMembers`
      ] = groupMembersWithUID;


      //! 5. APPLY ALL WRITES IN ONE REQUEST

      await fire
        .database()
        .ref()
        .update(updates);

      //! 6. UPDATE RETRACTABLE SHARING REGISTRY

      const sharingSnapshot = await fire
        .database()
        .ref("retractableSharingRegistry")
        .child(currentUID)
        .once("value");

      if (sharingSnapshot.exists()) {
        let sharingUpdates = {};

        sharingSnapshot.forEach((eachSharingRegistry) => {
          const eachSharingRegistryDetails = eachSharingRegistry.val();

          if (eachSharingRegistryDetails.sharedToUID === groupID) {
            sharingUpdates[
              `/retractableSharingRegistry/${currentUID}/${eachSharingRegistry.key}/sharedToEmail`
            ] = groupName;
          }
        });

        if (Object.keys(sharingUpdates).length > 0) {
          await fire
            .database()
            .ref()
            .update(sharingUpdates);
        }
      }


      //! 7. REFRESH UI
      await this.retrieveGroupDetails();

      this.props.dataCallBack(this.state.groupsArrayList);

      this.setState({
        showPopup: false,
        groupNameExist: false,
      });

      this.showNotification(
        localizationStrings.updateSuccessAlert,
        "success",
        "tc",
        5,
      );
    } catch (error) {
      console.error("updateGroupData Error:", error);
      throw error;
    } finally {
    }
  }

  // async updateGroupData(superAdminID) {
  //   //! CHECK IF GROUP NAME ALREADY EXISTS
  //   await fire
  //     .database()
  //     .ref("GroupManagement")
  //     .child(superAdminID)
  //     .child(auth.currentUser.uid)
  //     .once("value")
  //     .then((snapshot) => {
  //       if (snapshot.exists()) {
  //         snapshot.forEach((group) => {
  //           if (
  //             this.state.groupName === group.val().groupName &&
  //             this.state.row.groupName !== group.val().groupName
  //           ) {
  //             this.setState({
  //               groupNameExist: true,
  //             });
  //           }
  //         });
  //       }
  //     });

  //   if (this.state.groupNameExist === true) {
  //     this.showNotification(
  //       localizationStrings.nameExistsAlert,
  //       "error",
  //       "tc",
  //       5,
  //     );
  //     this.setState({ loading: false });
  //   } else {
  //     let groupMembersWithUID = {};
  //     var newGroupMembersUID = [];

  //     for (var i = 0; i < this.state.selectedMember.length; i++) {
  //       var eachGroupMember = this.state.selectedMember[i];

  //       groupMembersWithUID[eachGroupMember.memberUID] = {
  //         memberEmail: eachGroupMember.memberEmail,
  //         memberName: eachGroupMember.memberName,
  //         memberUID: eachGroupMember.memberUID,
  //       };

  //       await fire
  //         .database()
  //         .ref("groupAccounts")
  //         .child(superAdminID)
  //         .child("userGroups")
  //         .child(eachGroupMember.memberUID)
  //         .update({
  //           memberEmail: eachGroupMember.memberEmail,
  //         })
  //         .then(
  //           fire
  //             .database()
  //             .ref("groupAccounts")
  //             .child(superAdminID)
  //             .child("userGroups")
  //             .child(eachGroupMember.memberUID)
  //             .child("groups")
  //             .child(this.state.groupID)
  //             .update({
  //               groupAdminEmail: auth.currentUser.email,
  //               groupAdminUID: auth.currentUser.uid,
  //               groupID: this.state.groupID,
  //             }),
  //         );

  //       newGroupMembersUID.push(eachGroupMember.memberUID);
  //     }

  //     // console.log(this.state.prevSelectedMember);

  //     for (var i = 0; i < this.state.prevSelectedMember.length; i++) {
  //       var eachOldGroupMemberUID = this.state.prevSelectedMember[i].memberUID;

  //       if (newGroupMembersUID.includes(eachOldGroupMemberUID) === false) {
  //         // console.log(eachOldGroupMemberUID)

  //         await fire
  //           .database()
  //           .ref("groupAccounts")
  //           .child(superAdminID)
  //           .child("userGroups")
  //           .child(eachOldGroupMemberUID)
  //           .child("groups")
  //           .child(this.state.groupID)
  //           .remove();
  //       }
  //     }

  //     await fire
  //       .database()
  //       .ref("GroupManagement")
  //       .child(superAdminID)
  //       .child(auth.currentUser.uid)
  //       .child(this.state.groupID)
  //       .update({
  //         groupName: this.state.groupName,
  //         groupDesc: this.state.groupDesc,
  //         groupMembers: groupMembersWithUID,
  //       });

  //     await fire
  //       .database()
  //       .ref("retractableSharingRegistry")
  //       .child(auth.currentUser.uid)
  //       .once("value")
  //       .then((snapshot) => {
  //         if (snapshot.exists()) {
  //           snapshot.forEach((eachSharingRegistry) => {
  //             const eachSharingRegistryDetails = eachSharingRegistry.val();
  //             if (
  //               eachSharingRegistryDetails.sharedToUID === this.state.groupID
  //             ) {
  //               fire
  //                 .database()
  //                 .ref("retractableSharingRegistry")
  //                 .child(auth.currentUser.uid)
  //                 .child(eachSharingRegistry.key)
  //                 .update({
  //                   sharedToEmail: this.state.groupName,
  //                 });
  //             }
  //           });
  //         }
  //       });

  //     await this.retrieveGroupDetails();

  //     this.props.dataCallBack(this.state.groupsArrayList);

  //     this.setState({
  //       showPopup: false,
  //       loading: false,
  //     });

  //     this.showNotification(
  //       localizationStrings.updateSuccessAlert,
  //       "success",
  //       "tc",
  //       5,
  //     );
  //   }
  // }

  async retrieveGroupDetails() {
    if (this.state.superAdminID !== "") {
      await fire
        .database()
        .ref("GroupManagement")
        .child(this.state.superAdminID)
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          var tempArray = [];
          snapshot.forEach(function(childSnap) {
            tempArray.push(childSnap.val());
          });

          this.setState({
            groupsArrayList: tempArray,
          });
        });
    }

    return this.state.groupsArrayList;
  }

  filterSelectedMembers(data) {
    // console.log(data);
    var filteredMemberListArray = data;
    for (var i = 0; i < filteredMemberListArray.length; i++) {
      const eachMember = filteredMemberListArray[i];
      for (var a = 0; a < this.state.selectedMember.length; a++) {
        const eachSelectedMember = this.state.selectedMember[a];
        if (eachMember.memberEmail === eachSelectedMember.memberEmail) {
          const index = this.state.memberemaillistArray.indexOf(eachMember);
          // console.log(index);
          if (index > -1) {
            filteredMemberListArray.splice(index, 1);

            this.setState({
              memberemaillistArray: filteredMemberListArray,
            });
          }
        }
      }
    }
    // console.log(this.state.memberemaillistArray);
    return this.state.memberemaillistArray;
  }

  renderSelectMember(cell, row) {
    return (
      <div>
        <button
          className={"select-btn"}
          onClick={(e) => {
            e.preventDefault();

            const allMembersArrayList = this.state.memberemaillistArray;
            const selectedMembersArrayList = this.state.selectedMember;

            selectedMembersArrayList.push(row);
            allMembersArrayList.splice(allMembersArrayList.indexOf(row), 1);

            this.setState({
              memberemaillistArray: allMembersArrayList,
              selectedMember: selectedMembersArrayList,
            });
          }}
        >
          <span className="plusIcon">&#43;</span>
        </button>
      </div>
    );
  }

  Disable() {
    return <button disabled={true}>I am Disabled!</button>;
  }

  unselectMember(cell, row) {
    return (
      <div>
        <button
          class
          className={"unselect-btn"}
          onClick={(e) => {
            e.preventDefault();

            const selectMemberEmail = JSON.stringify(row.memberEmail);
            const yourEmail = JSON.stringify(auth.currentUser.email);

            if (selectMemberEmail != yourEmail) {
              const allMembersArrayList = this.state.memberemaillistArray;
              const selectedMembersArrayList = this.state.selectedMember;

              allMembersArrayList.push(row);
              selectedMembersArrayList.splice(
                selectedMembersArrayList.indexOf(row),
                1,
              );

              this.setState({
                memberemaillistArray: allMembersArrayList,
                selectedMember: selectedMembersArrayList,
              });
            } else {
              this.showNotification(
                localizationStrings.adminRemovalAlert,
                "error",
                "tc",
                5,
              );
            }
          }}
        >
          <span className="crossIcon">&times;</span>
        </button>
      </div>
    );
  }

  createCustomSearchFieldForm() {
    return (
      <SearchField
        // style={{ color: "blue" }}
        className="formSearchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        {/* <Button
          onClick={this.handleGroupDetailsPopupOpen}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {localizationStrings.editDetailsBtn}{" "}
          <span data-notify="icon" className="pe-7s-pen"></span>
        </Button> */}

        <span
          onClick={this.handleGroupDetailsPopupOpen}
          style={{ fontSize: "1.5em" }}
          data-notify="icon"
          className="pe-7s-pen"
          id="editDetailsIcon"
        ></span>
        {/* //! Popup for Group Details Button */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handleGroupDetailsPopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.groupDetailsHeader}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "30px 30px 40px 30px" }}>
            <form>
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupNameHeader}
                </ControlLabel>
                <FormControl
                  type="text"
                  placeholder={localizationStrings.groupNamePlaceholder}
                  onChange={this.handleGroupNameChange}
                  value={this.state.groupName}
                ></FormControl>
              </FormGroup>
              <br />
              <FormGroup>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.groupDescriptionHeader}
                </ControlLabel>
                <FormControl
                  style={{ height: "100px" }}
                  componentClass="textarea"
                  placeholder={localizationStrings.groupDescriptionPlaceholder}
                  onChange={this.handleGroupDescChange}
                  value={this.state.groupDesc}
                />
              </FormGroup>
              <br />
              <ControlLabel style={{ fontSize: "1.2em" }}>
                {localizationStrings.addMembersHeader}
              </ControlLabel>
              {/* <Multiselect
                style={{ fontSize: "1.15em" }}
                data={this.state.memberemaillistArray}
                valueField="memberEmail"
                textField="memberDisplay"
                onChange={this.handleSelectedMembers}
                value={this.state.selectedMemberValue}
                placeholder={localizationStrings.addMembersPlaceholder}
              ></Multiselect>
              <br />
              <br />
              <BootstrapTable
                data={this.state.selectedMember}
                bordered={true}
                pagination
                options={{
                  sizePerPage: 5,
                  hideSizePerPage: true,
                  deleteBtn: this.createCustomDeleteButton,
                  handleConfirmDeleteRow: this.customConfirmDialog,
                  afterDeleteRow: this.onAfterDeleteRow,
                  noDataText: localizationStrings.noDataTitle
                }}
                selectRow={{ mode: "checkbox" }}
                deleteRow
              >
                <TableHeaderColumn
                  dataField="memberName"
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.nameHeader}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="memberEmail"
                  isKey={true}
                  tdStyle={{ textAlign: "center" }}
                  thStyle={{ textAlign: "center" }}
                >
                  {localizationStrings.emailHeader}
                </TableHeaderColumn>
              </BootstrapTable> */}
              <div className="selectMembersTable">
                <BootstrapTable
                  data={this.filterSelectedMembers(
                    this.state.memberemaillistArray,
                  )}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    searchField: this.createCustomSearchFieldForm,
                    defaultSortName: "memberName", // default sort column name
                    defaultSortOrder: "asc", // default sort order
                    noDataText: localizationStrings.noDataTitle,
                    // deleteBtn: this.createGroupCustomDeleteButton,
                    // handleConfirmDeleteRow: this.customConfirmDialog,
                    // afterDeleteRow: this.createGroupOnAfterDeleteRow
                    // noDataText: localizationStrings.noDataTitle
                  }}
                  search
                >
                  <TableHeaderColumn
                    // dataSort
                    dataField="memberName"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="memberEmail"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    // dataField="memberEmail"
                    dataFormat={this.renderSelectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
                <ControlLabel style={{ fontSize: "1.2em" }}>
                  {localizationStrings.selectedMembersHeader}
                </ControlLabel>
                <BootstrapTable
                  data={this.state.selectedMember}
                  bordered={false}
                  pagination
                  options={{
                    sizePerPage: 5,
                    hideSizePerPage: true,
                    searchField: this.createCustomSearchFieldForm,
                    defaultSortName: "memberName", // default sort column name
                    defaultSortOrder: "asc", // default sort order
                    noDataText: localizationStrings.noDataTitle,
                    // defaultSortName: "memberName", // default sort column name
                    // defaultSortOrder: "asc" // default sort order
                    // deleteBtn: this.createGroupCustomDeleteButton,
                    // handleConfirmDeleteRow: this.customConfirmDialog,
                    // afterDeleteRow: this.createGroupOnAfterDeleteRow
                    // noDataText: localizationStrings.noDataTitle
                  }}
                  search
                  // selectRow={{ mode: "checkbox" }}
                  // deleteRow
                >
                  <TableHeaderColumn
                    // dataSort
                    dataField="memberName"
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.nameHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="memberEmail"
                    isKey={true}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  >
                    {localizationStrings.emailHeader}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    // dataField="memberEmail"
                    dataFormat={this.unselectMember}
                    tdStyle={{ textAlign: "center" }}
                    thStyle={{ textAlign: "center" }}
                  ></TableHeaderColumn>
                </BootstrapTable>
              </div>
              {/* <br /> */}
              <FormGroup style={{ display: "flex" }}>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={this.onSubmit}
                  disabled={this.state.loading}
                >
                  {this.state.loading
                    ? localizationStrings.loading
                    : localizationStrings.saveTitle}
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  onClick={this.handleGroupDetailsPopupClose}
                >
                  {localizationStrings.cancelTitle}
                </Button>
              </FormGroup>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default GroupDetailsButton;
